import { useSyncExternalStore } from 'react';

/** Cihaza özel tercihler (localStorage). Hesaba bağlı olanlar profiles'ta. */
export type Prefs = {
  theme: 'system' | 'light' | 'dark';
  fontScale: 1 | 1.12 | 1.25;
  reduceMotion: boolean;
  speechRate: number;
  /** Girişsiz ziyaretçinin içerik dili; girişli kullanıcıda profiles.content_lang esas. */
  contentLang: string | null;
  storyMode: 'cards' | 'full';
};

const KEY = 'brifing-prefs-v1';
const DEFAULTS: Prefs = {
  theme: 'system',
  fontScale: 1,
  reduceMotion: false,
  speechRate: 1.1,
  contentLang: null,
  storyMode: 'cards',
};

function load(): Prefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Prefs>) };
  } catch {
    // depolama kapalı ya da bozuk
  }
  return DEFAULTS;
}

let prefs = load();
const listeners = new Set<() => void>();

function apply() {
  const root = document.documentElement;
  if (prefs.theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', prefs.theme);
  root.style.setProperty('--reading-scale', String(prefs.fontScale));
  root.toggleAttribute('data-reduce-motion', prefs.reduceMotion);
}
apply();

export function getPrefs(): Prefs {
  return prefs;
}

export function setPrefs(patch: Partial<Prefs>) {
  prefs = { ...prefs, ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // depolama kapalı
  }
  apply();
  listeners.forEach((l) => l());
}

export function usePrefs(): Prefs {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => prefs
  );
}
